import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["stacked", "inverse", "border"];
import { memoizeDeep, safeMerge } from "../common/utilities";
const setRoot = memoizeDeep(function (_ref) {
  let {
    feedback,
    theme,
    size,
    padding,
    border,
    dismissible,
    inverse,
    stacked
  } = _ref;
  let cssRoot = {};
  cssRoot = feedback.root;

  if (typeof size === "string") {
    cssRoot = safeMerge(cssRoot, feedback.modifiers.size[size]);
  }

  if (padding) {
    cssRoot = safeMerge(cssRoot, feedback.modifiers.padding);
  }

  if (border) {
    cssRoot = safeMerge(cssRoot, feedback.modifiers.border);
  }

  if (dismissible) {
    cssRoot = safeMerge(cssRoot, feedback.modifiers.dismissible);
  }

  if (inverse) {
    cssRoot = safeMerge(cssRoot, feedback.modifiers.inverse);
  }

  if (stacked) {
    cssRoot = safeMerge(cssRoot, feedback.modifiers.stacked);
  }

  const _feedback$theme$theme = feedback.theme[theme],
        {
    stacked: stackedTheme,
    inverse: inverseTheme,
    border: borderTheme
  } = _feedback$theme$theme,
        commonTheme = _objectWithoutProperties(_feedback$theme$theme, _excluded);

  cssRoot = safeMerge(cssRoot, commonTheme);

  if (border) {
    cssRoot = safeMerge(cssRoot, borderTheme);
  }

  if (stacked) {
    cssRoot = safeMerge(cssRoot, stackedTheme);
  }

  if (inverse) {
    cssRoot = safeMerge(cssRoot, inverseTheme);
  }

  return cssRoot;
});
export default function (_ref2) {
  var _internalTheme$compon;

  let {
    internalTheme,
    theme,
    size,
    padding,
    border,
    dismissible,
    inverse,
    stacked
  } = _ref2;
  let cssRoot = {},
      actualTheme = theme;
  const feedback = internalTheme === null || internalTheme === void 0 ? void 0 : (_internalTheme$compon = internalTheme.components) === null || _internalTheme$compon === void 0 ? void 0 : _internalTheme$compon.feedback;
  /**
   * In v4, some themes have been renamed... but to
   * remain backward compatible, we simply map the old
   * name to the new one.
   */

  switch (theme) {
    case "information":
      actualTheme = "informational";
      break;

    case "success":
      actualTheme = "confirmation";
      break;

    default:
      break;
  }

  if (feedback) {
    cssRoot = setRoot({
      feedback,
      theme: actualTheme,
      size,
      padding,
      border,
      dismissible,
      inverse,
      stacked
    });
  }

  return {
    cssRoot
  };
}